import React, { useEffect } from "react";
import { IoIosMail } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";

const CheckMail = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleNavigation = (e) => {
      // Check if the user is trying to navigate away

      e.preventDefault();
      e.returnValue = true;
    };

    // Attach event listeners to prevent navigation
    window.addEventListener("beforeunload", handleNavigation);
    window.addEventListener("popstate", handleNavigation);
    document.addEventListener("keydown", handleNavigation);

    return () => {
      // Clean up event listeners when the component unmounts
      window.removeEventListener("beforeunload", handleNavigation);
      window.removeEventListener("popstate", handleNavigation);
      document.removeEventListener("keydown", handleNavigation);
    };
  }, []);

  useEffect(() => {
    // Check if the user manually entered a URL in the address bar
    if (window.location.pathname !== "/check-email") {
      // Redirect the user back to the restricted page
      navigate("/check-email");
    }
  }, [navigate]);

  return (
    <div className="text-center py-10 px-0 bg-email-bg h-screen">
      <div className="bg-white p-[60px] rounded-md inline-block mt-20 mx-auto">
        <div className="rounded-[200px] h-[200px] w-[200px] bg-[rgba(var(--primary-rgb),0.2)] my-0 mx-auto relative">
          <IoIosMail className="text-primary text-[100px] absolute right-12 top-14" />
        </div>
        <h1 className="font-black text-[40px] mb-[10px] text-primary">
          Perfect!
        </h1>
        <p className="text-xl m-0 text-navy-blue">
          Kindly check your mail to verify and complete your account creation.
        </p>
      </div>
    </div>
  );
};

export default CheckMail;
